export default {
  mounted() {
    document.body.addEventListener('copy', this.forbidCopy)
    document.querySelector('#watermark').style.setProperty('--bg-img', `url(${this.$store.state.user.watermark})`)
  },
  beforeDestroy() {
    document.body.removeEventListener('copy', this.forbidCopy)
    document.querySelector('#watermark').style.setProperty('--bg-img', '')
  },
  methods: {
    forbidCopy(e) {
      const warningText = '数据管理内容禁止复制粘贴！'
      const clipboardData = (e.clipboardData || window.clipboardData)
      clipboardData.setData('text/plain', warningText)
      this.$message.warning(warningText)
      e.preventDefault()
    }
  }
}
